import React, { useEffect, useState } from "react";
import { ARR_WHO_I_AM, HERO_CONTENT } from "../constants";
import spaceImg from "../assets/react-space.jpg";
import { motion } from "framer-motion";

const Banner = () => {
  const [isVisible, setIsVisible] = useState(false);

  const [text, setText] = useState("");
  const words = ARR_WHO_I_AM;
  const [wordIndex, setWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [delay, setDelay] = useState(150);
  const [showCursor, setShowCursor] = useState(true);

  const variants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    let typingTimeout;

    if (isVisible) {
      typingTimeout = setTimeout(() => {
        const currentWord = words[wordIndex];
        setText(
          isDeleting
            ? currentWord.substring(0, text.length - 1)
            : currentWord.substring(0, text.length + 1)
        );

        // Manage word deletion and transition
        if (!isDeleting && text === currentWord) {
          setDelay(1000); // Pause before starting to delete
          setIsDeleting(true);
        } else if (isDeleting && text === "") {
          setIsDeleting(false);
          setWordIndex((prev) => (prev + 1) % words.length); // Move to the next word
          setDelay(500); // Shorter delay before typing the next word
        } else {
          setDelay(isDeleting ? 200 : 150); // Adjust typing speed
        }
      }, delay);
    }

    return () => clearTimeout(typingTimeout); // Cleanup
  }, [text, isDeleting, wordIndex, words, isVisible, delay]);

  useEffect(() => {
    const cursorBlinkInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500); // Blink every 500ms

    return () => clearInterval(cursorBlinkInterval); // Cleanup
  }, []);

  return (
    <>
      <div className="lg:mb-35 flex items-center justify-center mt-32">
        <div className="flex flex-wrap">
          <motion.div
            className="flex flex-col items-center lg:items-start"
            initial="hidden"
            animate={isVisible ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 0.6 }} // Adjust the duration for a smoother effect
          >
            <h1 className="pb-16 text-6xl font-thin tracking-tight lg:mt-16 lg:text-8xl">
              Navneet Uniyal
            </h1>
            <span
              className="bg-gradient-to-r from-pink-300
           via-slate-500 to-purple-500 bg-clip-text text-3xl tracking-tight text-transparent"
            >
              Hi, I am a {text}{" "}
              <span
                className={`${
                  showCursor ? "inline-block w-1 h-8" : "inline-block w-0 h-8"
                }  bg-white animate-blink`}
              ></span>
            </span>
            <p className="my-2 max-w-xl py-6 font light tracking-tighter">
              {HERO_CONTENT}
            </p>
          </motion.div>
        </div>
      </div>
      <img
        src={spaceImg}
        alt="Decorative background"
        className="border-b border-neutral-900 absolute inset-0 w-full h-full object-cover opacity-30 lg:opacity-50 mix-blend-overlay mb-20 lg:h-[600px] -z-10"
      />
    </>
  );
};

export default Banner;
